import * as React from "react";

import { PercentageMask } from "src/util/Masks/PercentageMask";
import { formatCurrency } from "src/util/Masks/formatCurrency";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { PriceInfo } from './PriceInfo';
import { DisbursementInfo } from './DisbursementInfo';
import "./pricingInfo.scss";

interface IPricingInfoProps {
  trade: ITrade;
  userCanSeeCommission: boolean
}

export const PricingInfo: React.FC<IPricingInfoProps> = ({ trade, trade: { precatorio, tradePricing: { pricing } }, userCanSeeCommission }) => (
  <div className="region-container pricing-info">
    <span className="subtitle">Dados da Precificação</span>
    <div className="region-container">
      <PriceInfo trade={trade} />
      <div className="row">
        <span className="left description">Principal:</span>
        <span className="right description">{formatCurrency(precatorio?.principal)}</span>
      </div>
      <div className="row">
        <span className="left description">Juros:</span>
        <span className="right description">{formatCurrency(precatorio?.interest)}</span>
      </div>
      <div className="row">
        <span className="left description">Percentual do Credor:</span>
        <span className="right description">{PercentageMask(pricing.reducedPercentLender, 2, 2)}</span>
      </div>
      <div className="row">
        <span className="left description">Valor Atualizado:</span>
        <span className="right description">{formatCurrency(pricing?.updatedPrecatorioValue)}</span>
      </div>
      < DisbursementInfo trade={trade} />
      {userCanSeeCommission && (
        <>
          <div className="row">
            <span className="left description">Comissão:</span>
            <span className="right description">{PercentageMask(pricing?.commission?.officer?.userCommissionCalculated?.percentage ?? pricing?.commission?.officer?.full?.percentage, 2, 2)}</span>
          </div>
          <div className="row">
            <span className="left description">Valor da Comissão:</span>
            <span className="right description">{formatCurrency(pricing?.commission?.officer?.userCommissionCalculated?.value ?? pricing?.commission?.officer?.full?.value)}</span>
          </div>
          <div className="row">
            <span className="left description">Percentual de oferta:</span>
            <span className="right description">{PercentageMask(pricing?.desagioValue, 2, 2)}</span>
          </div>
        </>
      )}
    </div>
  </div>
);


// WEBPACK FOOTER //
// ./src/components/Refatoracao/TradeList/Components/PricingInfo/PricingInfo.tsx